module.exports = __webpack_public_path__ + "img/game.b54be057.jpg";